import { AuthenticationService } from './../../../../services/authentication.service';
import { SharedService } from './../../../../services/shared.service';
import { Component } from '@angular/core';
import { HeaderService } from '../../../../services/header.service';
import { MatDialog } from '@angular/material/dialog';
import { SwitchDialog, SwitchDebtorAccountDialogData } from '../../../shared/dialog/switch-dialog/switch-dialog';
import { AccountDebtorService } from '../../../../services/accountDebtor.service';
import { environment } from '../../../../environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HeaderTemplateData } from '../../../shared/dialog/dialog-data.interface';

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss']
})
export class SubheaderComponent {
    applicationName: string;
    isDashboard: boolean = false;
    defaulTitle: string;
    constructor(
        public headerService: HeaderService,
        private _sharedService: SharedService,
        public _authService: AuthenticationService,
        private dialog: MatDialog,
        public accountDebtorService: AccountDebtorService,
        private router: Router
    ) {
        this.applicationName = environment.Application;

        router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.isDashboard = event.url.indexOf("dashboards/main") != -1;
        });
    }

    toggleSideNav() {
        this._sharedService.sideNav.toggle();
    }

    logout() {
        this._authService.logout();
    }

    openSwitch() {
       let header={
            title:{
                leftTopTitle:{
                    title:{
                        text:"Switch Debtor Account",
                    },
                }
            }
        } as HeaderTemplateData;

        let data:SwitchDebtorAccountDialogData = {
            accountDebtorListing:this.accountDebtorService.AccountDebtors,
            header:header
        };

        this.dialog.open(SwitchDialog, {
            data:data
        });
    }

    counter(numberOfLayer: number) {
        return new Array(numberOfLayer ?? 0);
    }

}
